import { faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { getUuidV4, goToFocus, handleNumberOnly, validarCNPJ } from "../../../utils/utils";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../app/store";
import { useEffect, useRef, useState } from "react";
import { addAuthDownload, removeAuthDownload, removeAuthDownloadTodos } from "../../../features/manifestoSlice";
import { AutorizacaoDownloadInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import {  ButtonRemover, ButtonTrash, JTable, JTBody, JTHead, JvCaption } from "../../../components/Components";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";

const limite = 10;

const initialForm: AutorizacaoDownloadInterface = {
    id: 0,
    cpfcnpj: '',
}

export default function AutorizacaoDownload() {
    const dispatch = useDispatch();
    const lista = useSelector((state: RootState) => state.manifesto.manifesto.authDownload);
    const [form, setForm] = useState<AutorizacaoDownloadInterface>(initialForm);
    const [saldo, setSaldo] = useState<number>(0);
    const cnpjRef = useRef<HTMLInputElement>(null);
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();
    const [selecionado, setSelecionado] = useState<number | string>('');
    const validarPreenchimento = () => {

        if (form.cpfcnpj === "") {
            goToFocus(cnpjRef);
            alertModal('Informe um CNPJ.');
            return false;
        } else if (!validarCNPJ(form.cpfcnpj)) {
            goToFocus(cnpjRef);
            alertModal('CNPJ inválido.');
            return false;
        }

        if (lista.length >= limite) {
            alertModal('Limite máximo de 10 autorizações de download atingido.');
            return false;
        }

        if (lista.find(item => item.cpfcnpj === form.cpfcnpj)) {
            goToFocus(cnpjRef);
            alertModal('CNPJ já adicionado.');
            return false;
        }

        return true;
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleAdd = () => {
        if (validarPreenchimento()) {
            goToFocus(cnpjRef);
            dispatch(addAuthDownload({ ...form, id: getUuidV4() }));
            setForm(initialForm);
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id);

        const confirmed = await confirm({
            message: <>Deseja realmente remover <strong>CNPJ: {value.title}</strong> ?</>,
            title: "Confirmação"
        });

        if (confirmed) {
            dispatch(removeAuthDownload(value.id));
        }
        setSelecionado('');
    }

    const removerTudo = async () => {
        if (lista.length > 0) {
            const confirmed = await confirm({
                message: <>Remover todas as autorizações de download ?</>,
                title: "Confirmação"
            });
            
            if (confirmed) {
                dispatch(removeAuthDownloadTodos());
            }
        }
    }

    useEffect(() => {
        setSaldo(lista.length);
    }, [lista])

    return <div className="px-2">
        <Row className="g-2 mb-2">
            <Col md={'auto'} className="">
                <Form.Group  controlId="authdown-cnpj">
                    <Form.Label>CNPJ</Form.Label>
                    <InputGroup>
                        <Form.Control name="cpfcnpj" maxLength={14} type="text"
                            onKeyUp={handleNumberOnly} onChange={handleChange} value={form.cpfcnpj}
                            
                            ref={cnpjRef}
                        />
                        <Button variant="primary" onClick={handleAdd}>
                            <FontAwesomeIcon icon={faPlus} />
                        </Button>
                    </InputGroup>
                </Form.Group>
            </Col>
        </Row>

        <JTable>
            <JvCaption>({saldo} de {limite} no máximo)</JvCaption>
            <JTHead >
                <tr>
                    <th className="text-center" style={{ width: '2.5rem' }}>
                        <ButtonTrash onClick={() => removerTudo()} icon={faTrashAlt} />
                    </th>
                    <th>CNPJ</th>
                </tr>
            </JTHead>

            <JTBody>
                {lista?.map((item: AutorizacaoDownloadInterface) => (
                    <tr key={item.id} className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                        <td className="text-center">
                            <ButtonRemover onClick={() => handleRemover({ id: item.id, title: item.cpfcnpj })} />
                        </td>
                        <td>{item.cpfcnpj}</td>
                    </tr>
                ))}
            </JTBody>
        </JTable>
        {ConfirmModal}
        {ModalMessageEl}
    </div>
}
